
import { DropDownOptions } from "devextreme-react/drop-down-box";
import { Form, GroupItem, SimpleItem } from "devextreme-react/form";
import { forwardRef, useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { DropDownGrid } from "../../components";
import { getApiParams } from "../../redux/auth";
import { BodyType, createRequest } from "../../redux/base/request";
import { ApiResponse, verfiyResponse } from "../../redux/base/types/saga";
import { getLocalized } from "../../redux/localization";
import { Product } from "../products/types";
import { RequestContract, Users } from "./type";

const CreateAdminContract = forwardRef<any, { data: RequestContract, lookup: any }>(
    ({ data }, ref) => {
        const localize = useSelector(getLocalized);
        const [users, setUsers] = useState<Users[]>([]);
        const [products, setProducts] = useState<Product[]>([])
        const { token, lang } = useSelector(getApiParams);
        const [, setId] = useState("");

        const getUsers = useCallback((async () => {
            const response: ApiResponse<Users[]> = await createRequest({
                method: "GET",
                url: "api/admin/accounts/get-users",
                bodyType: BodyType.formdata,
                token,
                body: {},
                lang,
            });
            if (verfiyResponse(response)) {
                setUsers(response.Result)
            }
        }
        ), [token, lang])
        const getProducts = useCallback((async () => {
            const response: ApiResponse<Product[]> = await createRequest({
                method: "GET",
                url: "api/admin/products",
                bodyType: BodyType.formdata,
                token,
                body: {},
                lang,
            });
            if (verfiyResponse(response)) {
                setProducts(response.Result)
            }
        }
        ), [token, lang])
        useEffect(() => {
            getUsers();
            getProducts();
        }, [getUsers, getProducts])

        return (
            <form>
                <Form
                    key="id"
                    formData={data}
                    ref={ref}
                    showColonAfterLabel={true}
                    validationGroup='createAccountContract'
                >
                    <GroupItem >
                        <SimpleItem
                            dataField={"startDate"}
                            editorType="dxDateBox"
                            label={{
                                text: localize.getString("startDate")
                            }}
                            editorOptions={{
                                dateSerializationFormat: "yyyy-MM-dd"
                            }}
                        >

                        </SimpleItem>
                        <SimpleItem
                            dataField={"endDate"}
                            editorType="dxDateBox"
                            label={{
                                text: localize.getString("endDate")
                            }}
                            editorOptions={{
                                dateSerializationFormat: "yyyy-MM-dd"
                            }}
                        >
                        </SimpleItem>
                        <SimpleItem
                            dataField="userId"
                            editorType="dxLookup"
                            label={{ text: localize.getString("user") }}
                            render={(item: any) => (
                                <DropDownGrid
                                    dataSource={users}
                                    columns={["Name", "Surname", "Email", "PhoneNumber"]}
                                    displayExpr="Name"
                                    returnSelectedId={async (id: any) => {
                                        item.editorOptions.value = id;
                                        data.userId = id
                                        setId(id);
                                    }}
                                    value={data.userId}
                                    dropDownOptions={{ width: 900 }} />
                            )}
                        >
                            <DropDownOptions closeOnOutsideClick showTitle={false} />
                        </SimpleItem>
                        <SimpleItem
                            dataField="productCardId"
                            editorType="dxLookup"
                            label={{ text: localize.getString("product") }}
                            render={(item: any) => (
                                <DropDownGrid
                                    dataSource={products}
                                    columns={["Code", "Name", "Description", "Deposit"]}
                                    displayExpr="Name"
                                    returnSelectedId={async (id: any) => {
                                        item.editorOptions.value = id;
                                        data.productCardId = id
                                        setId(id);
                                    }}

                                    value={data.productCardId}
                                    dropDownOptions={{ width: 900 }} />
                            )}
                        >
                            <DropDownOptions closeOnOutsideClick showTitle={false} />
                        </SimpleItem>
                    </GroupItem>
                </Form>
            </form>
        );
    }
);


export default CreateAdminContract